module.exports = {

  initialize: function (permissionsFactory) {
    this.canvas = INKIVE.Tool.getInstance().editor.canvas;
    this.permissionsFactory = permissionsFactory;
  },

  restrictMovement: function (element, restrictions, data) {
    var r = restrictions[0];
    if (!r) return data;

    return {
      x: r['horizontal'] ? data.x : 0,
      y: r['vertical'] ? data.y : 0
    };
  },

  restrictMargin: function (element, restrictions, data) {
    var r = restrictions[0];
    if (!r) return data;

    var margin = r['size'];
    var box = svgedit.utilities.getBBox(element);
    var dx = data.x;
    var dy = data.y;

    if (box.x + data.x < margin) {
      dx = margin - box.x;
    } else if (box.x + box.width + data.x > this.canvas.contentW - margin) {
      dx = this.canvas.contentW - margin - box.x - box.width;
    }

    if (box.y + data.y < margin) {
      dy = margin - box.y;
    } else if (box.y + box.height + data.y > this.canvas.contentH - margin) {
      dy = this.canvas.contentH - margin - box.y - box.height;
    }

    return { x: dx, y: dy };
  }
};
